import script from "./StopObjectsCollection.vue?vue&type=script&lang=ts&setup=true"
export * from "./StopObjectsCollection.vue?vue&type=script&lang=ts&setup=true"

import "./StopObjectsCollection.vue?vue&type=style&index=0&id=ee3b898c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee3b898c"]])

export default __exports__